module.exports = __webpack_public_path__ + "static/media/undraw_hacker_mindset_gjwq.1feaa5be.svg";